import { AppConfig } from "./loadConfigJson";

let appConfig: AppConfig | null = null;

export const setConfig = (config: AppConfig) => {
  appConfig = config;
};

export const getConfig = (): AppConfig => {
  if (!appConfig) {
    throw new Error('Config not set! Ensure it is initialized before use.');
  }
  return appConfig;
};
